import { render } from "./Users.vue?vue&type=template&id=24350eea&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=24350eea&lang=scss"
import "./Users.vue?vue&type=style&index=1&id=24350eea&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24350eea"]])

export default __exports__